import { render, staticRenderFns } from "./RootFooterDenmark.vue?vue&type=template&id=5feba453&scoped=true"
import script from "./RootFooterDenmark.vue?vue&type=script&lang=js"
export * from "./RootFooterDenmark.vue?vue&type=script&lang=js"
import style0 from "./RootFooterDenmark.vue?vue&type=style&index=0&id=5feba453&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feba453",
  null
  
)

export default component.exports